/** HanMiles earned per km of a journey (its great-circle distance), whatever the mode. */
export const HAN_MILES_PER_KM = 1;

/** HanMiles that take 1 Han (¥1) off a flight fare. */
export const HAN_MILES_PER_HAN = 10;

/** The largest share of a flight's fare HanMiles can pay: they discount a flight, never buy one. */
export const HAN_MILES_MAX_FARE_SHARE = 0.5;

export interface HanMilesRedemption {
  /** Han taken off the fare. */
  discountHan: number;
  /** HanMiles spent: `discountHan × HAN_MILES_PER_HAN`. */
  hanMilesRedeemed: number;
}

const NO_REDEMPTION: HanMilesRedemption = { discountHan: 0, hanMilesRedeemed: 0 };

/**
 * The largest discount `hanMiles` buy on a flight fare: whole Han, at most
 * {@link HAN_MILES_MAX_FARE_SHARE} of the fare.
 */
export function redeemHanMilesOn({
  flightFareCny,
  hanMiles,
}: {
  flightFareCny: number;
  hanMiles: number;
}): HanMilesRedemption {
  const discountHan = Math.max(
    0,
    Math.min(
      Math.floor(flightFareCny * HAN_MILES_MAX_FARE_SHARE),
      Math.floor(hanMiles / HAN_MILES_PER_HAN),
    ),
  );
  return discountHan === 0
    ? NO_REDEMPTION
    : { discountHan, hanMilesRedeemed: discountHan * HAN_MILES_PER_HAN };
}

/** Locale-formatted HanMiles amount without a unit. */
export function formatHanMilesAmount(hanMiles: number): string {
  return Math.round(hanMiles).toLocaleString("en-US");
}

/** `1,234 HanMiles`, `1 HanMile`. */
export function formatHanMiles(hanMiles: number): string {
  const amount = formatHanMilesAmount(hanMiles);
  return `${amount} ${amount === "1" ? "HanMile" : "HanMiles"}`;
}
